module.exports = __webpack_public_path__ + "img/undraw_taking_selfie_lbo7.070dea4d.svg";